import { api, notify } from 'services';
import { FileHelper } from 'utils';

export const useDocument = () => {
  const downloadDocument = async (id: number): Promise<void> => {
    try {
      const { data } = await api.get(`document/temporary-url/${id}`);

      FileHelper.urlClick(data);
    } catch (error) {
      console.log(error)
      notify('error', 'Não foi possível baixar o arquivo')
    }
  };

  const removeDocument = async (id: number | string): Promise<void> => {
    try {
      await api.delete(`documents/${id}`);
      notify('success', 'Documento removido com sucesso')
    } catch (error) {
      console.log(error)
      notify('error', 'Não foi possível remover o arquivo')
    }
  };

  return {
    downloadDocument,
    removeDocument,
  };
};

export type PaginationCacheHook = ReturnType<typeof useDocument>;
